// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Antigua & Barbuda */
const AG = /^(?:268(?:464|7(?:1[3-9]|[28]\d|3[0246]|64|7[0-689]))\d{4})$/;

export default AG;
